import { v4 as uuidv4 } from 'uuid';
export class PostModel{
    _id?: any;
    uuid: string;
    revision: string;
    status: string;
    vrsn: string;
    create_date: Date;
    update_date: Date;
    poster_property: PosterProperty;
    post_id: string;
    reaction_summary: ReactionSummary;
    task_guid: string;
    channel_id:string;
    comments?: number;
    object_type?: string;
    post_message?: string;
    agent_participants?: string;
    created_by?: string;
    updated_by?: string;
    active_session?: string;
    page_id?: string;
    channel: string;

    constructor(pageId: string){
        this.uuid = uuidv4();
        this.revision = uuidv4();
        this.status = "ACTIVE";
        this.vrsn = "ailedger-v1"
        this.create_date = new Date();
        this.update_date = new Date();
        this.page_id = pageId;
        this.poster_property = new PosterProperty;
        this.reaction_summary = new ReactionSummary;
      }
    
}

export class PosterProperty{
    id: string;
    name: string;
}

export class ReactionSummary{
    like: number;
    love: number;
    haha: number;
    sad: number;
    wow: number;
    angry: number;
    care: number;

}

  